
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div
      style={{
        zIndex: 100,
      backgroundImage: "url(https://redlionandcompany.com/Assets/kamarezOfArica/footerbgimg.jpg)",
     
      backgroundSize: "cover",
      backgroundPosition: "center",
        textAlign: "center",
      
        position: "relative",
      }}
    >
      {/* Soft fade overlay */}
      <div
        style={{
        backgroundColor: "#f0eaddb2",
          paddingTop: "60px",
          paddingBottom: "20px",
        }}
      >
        {/* Logo */}
        <img
          loading="lazy"
          src="https://africantraveltour.com/assets/img/aftt-logo.webp"
          alt="African Travel Tour Logo"
          style={{
            width: "200px",
            marginBottom: "20px",
          }}
        />

        {/* Navigation Links */}
        <nav
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "2rem",
            flexWrap: "wrap",
            marginBottom: "50px",
            fontSize: "1.1rem",
          }}
        >
          <Link to="/" style={{ color: "#333", textDecoration: "none" }}>
            Home
          </Link>
          <Link to="/about" style={{ color: "#333", textDecoration: "none" }}>
            About Us
          </Link>
          <Link
            to="/safaris_packages"
            style={{ color: "#333", textDecoration: "none" }}
          >
            Safaris
          </Link>
          <Link
            to="/climbing_tours"
            style={{ color: "#333", textDecoration: "none" }}
          >
            Climbing
          </Link>
          <Link
            to="/contact"
            style={{ color: "#333", textDecoration: "none" }}
          >
            Contact Us
          </Link>
        </nav>

        {/* Contact Info Section */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems:'center',
            flexWrap: "wrap",
            gap: "3rem",
            marginBottom: "50px",
          }}
        >
          {/* Call Us */}
          <div>
            <h5 style={{ fontWeight: "700", marginBottom: "10px" }}>CALL US</h5>
            <p style={{ margin: 0 }}>
              <a
                href="tel:+255784994151"
                className="text-decoration-none"
                style={{ color: "#7a3d3d" }}
              >
                +255 784 994 151
              </a>
            </p>
          </div>

          {/* Location */}
          <div>
            <h5 style={{ 
             
               marginBottom: "10px" }}>
              HEAD OFFICE
            </h5>
            <p style={{ margin: 0 , color:'#7a3d3d'}}>
              P.O Box 14421 Boma Road, <br />
              Arusha – Tanzania
            </p>
          </div>

          {/* Mail Us */}
          <div>
            <h5 style={{ fontWeight: "700", marginBottom: "10px" }}>MAIL US</h5>
            <p style={{ margin: 0 }}>
              <a
                href="mailto:booking@africantraveltour.com"
                className="text-decoration-none"
                style={{ color: "#7a3d3d" }}
              >
                booking@africantraveltour.com
              </a>
            </p>
          </div>
        </div>

        {/* Social Links */}
        <div className="d-flex justify-content-center align-items-center gap-3 mb-4">
          <a
            href="https://www.facebook.com/africantraveltour"
            target="_blank"
            rel="noopener noreferrer"
            style={{color:'white'}}
          >
            <i className="fab fa-facebook-f fa-lg" style={{color:'#1877F2'}}/>
          </a>

          <a
            href="https://www.tripadvisor.com/Attraction_Review-g6940195-d14008647-Reviews-African_Travel_Tour-Arusha_National_Park_Arusha_Region.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-tripadvisor fa-2x"></i>
          </a>
        </div>

        {/* Copyright */}
        <p style={{ fontSize: "0.95rem", color: "#333" }}>
          ©{" "}
          <a href="/" style={{ color: "#7a3d3d", textDecoration: "none" }}>
            African Travel Tour
          </a>{" "}
          All Rights Reserved. Developed by{" "}
          <a
            href="https://redlionandcompany.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-decoration-none"
            style={{ color: "#7a3d3d" }}
          >
            Red Lion & Co
          </a>
        </p>
      </div>
    </div>
  );
}
